import { Filter } from 'mk/bazaar/product/filter/filterUtils';
import { FacetsData } from 'mk2/apps/bazaar/components/FacetsFilter';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

export interface Checked {
    [productId: number]: true;
}

export interface WishlistLoadApiAction extends Action {
    readonly filter: Filter;
}

export const WISHLIST_LOAD_API_REQUEST = 'WISHLIST_LOAD_API_REQUEST';

export interface WishlistLoadApiRequestAction extends WishlistLoadApiAction, APIRequestAction {
    readonly type: typeof WISHLIST_LOAD_API_REQUEST;
}

export interface WishlistLoadNormalizedResponse extends NormalizedResponse {
    readonly result: {
        products: number[];
        discountedProducts: number[];
        complaints: {
            [productId: number]: number[];
        };
    };
}

export const WISHLIST_LOAD_API_SUCCESS = 'WISHLIST_LOAD_API_SUCCESS';

export interface WishlistLoadApiSuccessAction
    extends WishlistLoadApiAction,
        APISuccessAction<WishlistLoadNormalizedResponse> {
    readonly type: typeof WISHLIST_LOAD_API_SUCCESS;
    readonly facets: FacetsData;
    readonly hits: number;
    readonly checked: Checked;
}

export const WISHLIST_LOAD_API_FAILURE = 'WISHLIST_LOAD_API_FAILURE';

export interface WishlistLoadApiFailureAction extends WishlistLoadApiAction, APIFailureAction {
    readonly type: typeof WISHLIST_LOAD_API_FAILURE;
}

export const wishlistLoadApi = {
    request: (filter: Filter): WishlistLoadApiRequestAction => ({
        type: WISHLIST_LOAD_API_REQUEST,
        filter,
    }),
    success: (
        filter: Filter,
        facets: FacetsData,
        hits: number,
        checked: Checked,
        response: WishlistLoadNormalizedResponse,
    ): WishlistLoadApiSuccessAction => ({
        type: WISHLIST_LOAD_API_SUCCESS,
        filter,
        facets,
        hits,
        checked,
        response,
    }),
    failure: (filter: Filter, error: any): WishlistLoadApiFailureAction => ({
        type: WISHLIST_LOAD_API_FAILURE,
        filter,
        error,
    }),
};

export const WISHLIST_LOAD = 'WISHLIST_LOAD';

export interface WishlistLoadAction extends WishlistLoadApiAction {
    readonly type: typeof WISHLIST_LOAD;
}

export const wishlistLoad = (filter: Filter): WishlistLoadAction => ({
    type: WISHLIST_LOAD,
    filter,
});
